var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenubar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 21,
    viewBox: "0 0 35 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5026_8602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.56638C0.116667 9.21638 0.116667 8.86638 0.233333 8.63305C1.05 6.06638 3.26667 4.43305 5.95 4.43305C9.33333 4.43305 12.7167 4.43305 15.9833 4.43305C16.2167 4.43305 16.3333 4.31638 16.5667 4.19971C18.3167 1.86638 20.7667 0.466381 23.6833 0.116381C28.8167 -0.466952 33.7167 3.14971 34.7667 8.28305C35.8167 13.883 32.3167 19.2497 26.7167 20.2997C22.6333 21.1164 19.1333 19.7164 16.5667 16.4497C16.45 16.2164 16.2167 16.2164 15.9833 16.2164C12.6 16.2164 9.33333 16.2164 5.95 16.2164C3.73333 16.2164 2.1 15.283 0.816667 13.533C0.35 12.833 0.116667 12.133 0 11.3164C0 11.083 0 10.9664 0 10.9664C0 10.4997 0 10.033 0 9.56638ZM33.4833 10.2664C33.4833 5.48305 29.6333 1.51638 24.7333 1.51638C19.95 1.51638 15.9833 5.36638 15.9833 10.2664C15.9833 15.0497 19.8333 19.0164 24.7333 19.0164C29.5167 19.0164 33.4833 15.0497 33.4833 10.2664ZM15.5167 5.83305C15.4 5.83305 15.4 5.83305 15.4 5.83305C12.1333 5.83305 8.98333 5.83305 5.71667 5.83305C2.91667 5.83305 0.933333 8.63305 1.63333 11.433C2.21667 13.2997 3.85 14.583 5.83333 14.583C8.98333 14.583 12.0167 14.583 15.1667 14.583C15.2833 14.583 15.4 14.583 15.5167 14.583C14.2333 11.6664 14.2333 8.74971 15.5167 5.83305Z",
    fill: "#06C9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.416 10.2669C20.416 7.81688 22.3993 5.95021 24.8493 5.95021C27.1827 5.83354 29.166 7.81688 29.166 10.2669C29.166 12.7169 27.1827 14.5835 24.7327 14.5835C22.3993 14.5835 20.416 12.6002 20.416 10.2669ZM24.8493 13.1835C26.4827 13.1835 27.766 11.7835 27.6493 10.1502C27.6493 8.63354 26.2493 7.35021 24.7327 7.35021C23.0993 7.35021 21.816 8.75021 21.816 10.2669C21.9327 11.9002 23.216 13.1835 24.8493 13.1835Z",
    fill: "#06C9F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5026_8602"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 20.4167,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenubar);
export default __webpack_public_path__ + "static/media/menubar.5e5717e80d4c045b609aad806ea7721f.svg";
export { ForwardRef as ReactComponent };